module.exports = __webpack_public_path__ + "static/news5pic5-d531c0e8a0fe0d182ef94889cc809a11.jpg";